import { useQuery } from '@apollo/react-hooks';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { getAGGClient } from '@confluence/graphql';
import { isErrorMarkedAsHandled, markErrorAsHandled } from '@confluence/graphql-error-processor';
import { useSessionData } from '@confluence/session-data';

import { BillingUrlsQuery } from '../../graphql/BillingUrlsQuery.agggraphql';

type UseGetChangeOfferingAddPaymentLinkProps = {
	skip?: boolean;
	isProductUser: boolean;
	isTrial: boolean;
};
export const useGetChangeOfferingAddPaymentLink = ({
	skip,
	isProductUser,
	isTrial,
}: UseGetChangeOfferingAddPaymentLinkProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { cloudId } = useSessionData();

	const { data, error, loading } = useQuery(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
		BillingUrlsQuery,
		{
			client: getAGGClient(),
			variables: {
				cloudId,
				productKey: 'confluence.ondemand',
				offeringKey: '2eda1119-fab4-4699-ab37-ff8f12052cde',
				isTrial,
				isProductUser,
			},
			skip,
		},
	);

	if (error && !isErrorMarkedAsHandled(error)) {
		createAnalyticsEvent({
			type: 'sendTrackEvent',
			data: {
				action: 'failed',
				actionSubject: 'billingUrlsQuery',
				source: 'autoUpgradeAwarenessModal',
				attributes: {
					growthFeature: 'autoUpgradeAwarenessModal',
					isProductUser,
					isTrial,
					error: error?.message,
				},
			},
		}).fire();

		markErrorAsHandled(error);
	}

	let changeOfferingLink, addPaymentDetailsLink;

	if (isTrial) {
		const configurePaymentLink = isProductUser
			? data?.tenantContexts[0]?.entitlementInfo?.entitlement?.subscription?.accountDetails
					?.invoiceGroup?.experienceCapabilities?.configurePaymentV2?.experienceUrl
			: data?.tenantContexts[0]?.entitlementInfo?.entitlement?.subscription?.accountDetails
					?.invoiceGroup?.experienceCapabilities?.configurePayment?.experienceUrl;

		const addPaymentMethodLink = isProductUser
			? data?.tenantContexts[0]?.entitlementInfo?.entitlement?.transactionAccount
					?.experienceCapabilitiesV2?.addPaymentMethod?.experienceUrl
			: data?.tenantContexts[0]?.entitlementInfo?.entitlement?.transactionAccount
					?.experienceCapabilities?.addPaymentMethod?.experienceUrl;

		addPaymentDetailsLink = configurePaymentLink || addPaymentMethodLink;
	} else {
		changeOfferingLink = isProductUser
			? data?.tenantContexts[0]?.entitlementInfo?.entitlement?.experienceCapabilities
					?.changeOfferingV2?.experienceUrl
			: data?.tenantContexts[0]?.entitlementInfo?.entitlement?.experienceCapabilities
					?.changeOffering?.experienceUrl;
	}

	return {
		loading,
		error,
		addPaymentDetailsLink,
		changeOfferingLink,
	};
};
